import axios from 'axios';
import { BASE, getHeaders } from './config'

export function getMalfactions() {
    return axios.get(`${BASE}/malfactions`, { headers: getHeaders() });
}
export function addMalfaction(data) {
    return axios.post(`${BASE}/malfactions`, data, { headers: getHeaders() });
}
export function deleteMalfaction(id) {
    return axios.delete(`${BASE}/malfactions/${id}`, { headers: getHeaders() });
}
export function editMalfaction(id, data) {
    return axios.put(`${BASE}/malfactions/${id}`,data , { headers: getHeaders() });
}